<template>
  <section
    id="recentharvestslides"
  >
    <section
      v-for="(page, index) in pages"
      :key="'harvestpage' + index"
      :data-background-video="videoUrl"
      :data-background-image="gifUrl"
      data-background-video-loop="true"
      data-background-opacity="0.4"
    >
      <div
        class="sl-block"
        data-block-type="text"
        style="
          width: 100%;
          left: 29px;
          top: 84px;
          height: auto;
          margin-bottom: 20px;
        "
      >
        <div
          class="sl-block-content"
          data-placeholder-tag="h2"
          data-placeholder-text="Title Text"
          style="text-align: left; z-index: 10"
          dir="ui"
        >
          <h2 style="text-align: center; font-family: Poppins">
            Recent Harvests
          </h2>
        </div>
      </div>

      <div
        class="sl-block"
        data-block-type="table"
        style="
          height: auto;
          min-width: 120px;
          width: 100%;
          left: 29px;
          top: 175.5px;
          min-height: 450px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <table>
          <tbody>
            <tr v-for="harvest in page" :key="'lc' + harvest.lifecycle_id">
              <td style="font-size: 0.8em">{{ harvest.strainName }}</td>
              <td style="font-size: 0.8em">{{ harvest.plantCount }} plants</td>
              <td style="font-size: 0.8em">
                {{ moment(harvest.harvestDate).fromNow() }}
              </td>
              <td style="font-size: 0.8em">
                {{ harvest.totalWetWeight.toFixed(2) }} lbs
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "",
  props: ["value"],
  components: {},
  beforeMount() {
    if (navigator.userAgent.indexOf("Silk") > 0) {
      this.gifUrl = "/img/presentationbackgrounds/harvestTime.gif";
    } else {
      this.videoUrl = "/img/presentationbackgrounds/harvestTime.mp4";
    }
    this.refresh();
  },
  mounted() {},
  data() {
    return {
      moment: moment,
      harvestSchedule: [],
      gifUrl: null,
      videoUrl: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
    pages() {
      let pages = [];
      for (let i = 0; i < this.value.length; i++) {
        if (i % 8 == 0) {
          pages[pages.length] = [];
        }
        pages[pages.length - 1].push(this.value[i]);
      }
      return pages;
    },
  },
  watch: {},
  methods: {
    refresh() {},
  },
};
</script>
<style>
</style>

